import type { UIStateAPI } from "@/types";
import type { HandednessStateAPI } from "@/state/handedness";

export type Adapter = {
  startBridge: () => () => void;
  hydrateFromSession: (screen: Record<string, unknown> | null | undefined) => void;
  normalizeSocketPatch?: (
    patch: Record<string, unknown>
  ) => { path: string; value: unknown }[];
};

interface RegistryDeps {
  readonly store: any;
  readonly uiState: UIStateAPI;
  readonly eventBus: any;
  readonly getPath: (key: string) => string | null;
  readonly persist: () => void;
  readonly handedness?: HandednessStateAPI | null;
}

export const createAdapterRegistry = (deps: RegistryDeps) => {
  const adapters: Adapter[] = [];
  const cleanups: (() => void)[] = [];

  const register = (adapterFactory: (deps: RegistryDeps) => Adapter) => {
    const adapter = adapterFactory(deps);
    adapters.push(adapter);
    const stop = adapter.startBridge();
    cleanups.push(stop);
  };

  const hydrateFromSession = (screen: Record<string, unknown> | null | undefined) => {
    for (const a of adapters) {
      try {
        a.hydrateFromSession(screen);
      } catch {}
    }
  };

  const normalizeSocketPatch = (patch: Record<string, unknown>) => {
    const patches: { path: string; value: unknown }[] = [];
    for (const a of adapters) {
      try {
        const res = a.normalizeSocketPatch?.(patch);
        if (Array.isArray(res)) patches.push(...res);
      } catch {}
    }
    return patches;
  };

  const destroy = () => {
    for (const c of cleanups) {
      try {
        c();
      } catch {}
    }
  };

  return { register, hydrateFromSession, normalizeSocketPatch, destroy };
};

